import { inject, Injectable } from '@angular/core'
import {
	ActivatedRouteSnapshot,
	CanActivate,
	CanActivateChild,
	GuardResult,
	MaybeAsync,
	Router,
	RouterStateSnapshot,
} from '@angular/router'
import { EnvironmentsHelperService } from '@environments/core/services/environments-helper.service'

@Injectable({
	providedIn: 'root',
})
export class TechnicalWorksGuard implements CanActivate, CanActivateChild {
	private readonly _router: Router = inject<Router>(Router)
	private readonly _environmentsHelperService: EnvironmentsHelperService =
		inject<EnvironmentsHelperService>(EnvironmentsHelperService)

	private _canRedirect(state: RouterStateSnapshot): boolean {
		const isTechWorks: boolean = this._environmentsHelperService.techWorks
		const isTechUrl: boolean = state.url.includes('technical-works')

		if (isTechWorks && !isTechUrl) {
			this._router.navigate(['technical-works'])
			return false
		}

		if (!isTechWorks && isTechUrl) {
			this._router.navigate(['/'])
		}

		return true
	}

	canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		return this._canRedirect(state)
	}

	canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
		return this.canActivate(childRoute, state)
	}
}
